export type TokenType = 'KNOCK';

interface CustomJwtResponse {
  token: string;
}

export async function fetchCustomJwt(tokenType: TokenType) {
  const response = await fetch(`/api/permissions/v2/app/${tokenType}/jwt`);
  if (!response.ok) {
    return undefined;
  }
  return (await response.json()) as CustomJwtResponse;
}
